import { Link } from "react-router-dom";
import { motion } from "framer-motion";

export default function FinalCTA() {
  return (
    <section
      className="relative overflow-hidden border-t border-white/5 px-6 py-24 md:px-12 md:py-32"
      data-testid="final-cta-section"
    >
      <div className="pointer-events-none absolute inset-0 grid-bg radial-fade opacity-40" />

      <div className="pointer-events-none absolute left-1/2 top-1/2 h-[400px] w-[700px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-[#00E5FF]/15 blur-[120px]" />

      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.7 }}
        className="relative mx-auto max-w-3xl text-center"
      >
        <div className="text-[11px] font-bold uppercase tracking-[0.22em] text-[#00E5FF]">
          See Your Page Before You Activate
        </div>

        <h2 className="mt-4 font-display text-3xl font-semibold leading-[1.05] tracking-tight sm:text-4xl lg:text-5xl">
          Turn Online Interest Into
          <br />
          More Restaurant Visits.
        </h2>

        <p className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-zinc-400 md:text-lg">
          We&apos;ll build a TapToTable Page for your restaurant before you
          pay. Review the customer experience, request any changes you&apos;d
          like, and activate only when you&apos;re completely satisfied.
        </p>

        <p className="mx-auto mt-4 max-w-2xl text-sm leading-relaxed text-zinc-300">
          After activation, use your secure TapToTable Dashboard to create and
          update Promotions &amp; Events, change photos and restaurant details,
          manage customer actions, and monitor customer activity and supported
          analytics.
        </p>

        <div className="mt-6 inline-flex flex-wrap items-center justify-center rounded-2xl border border-[#00E5FF]/30 bg-[#00E5FF]/10 px-4 py-3 text-sm text-zinc-100">
          <strong className="text-white">
            $59/month
          </strong>

          <span className="mx-2 text-zinc-400">
            •
          </span>

          <span>
            Hosting, customer activity, supported analytics, updates, and support included. Cancel anytime.
          </span>
        </div>

        <div className="mt-10 flex flex-col items-stretch justify-center gap-3 sm:flex-row sm:items-center">
          <Link
            to="/signup"
            className="pulse-ring inline-flex items-center justify-center gap-2 rounded-full bg-[#00E5FF] px-7 py-4 text-base font-semibold text-black transition-all hover:bg-[#66FFFF]"
            data-testid="final-cta-button"
          >
            Build My TapToTable Page
          </Link>

          <a
            href="#pricing"
            className="inline-flex items-center justify-center gap-2 rounded-full border border-white/10 bg-white/5 px-7 py-4 text-base font-semibold text-white transition-all hover:bg-white/10"
            data-testid="final-cta-pricing"
          >
            See What&apos;s Included
          </a>
        </div>

        <p className="mx-auto mt-5 max-w-xl text-xs leading-relaxed text-zinc-500">
          Built for food businesses that want a simpler way to promote
          Promotions &amp; Events and other timely reasons to visit — and turn
          online interest into more visits, orders, and repeat customers.
        </p>
      </motion.div>
    </section>
  );
}
